
export const borderX = v => {
  return {
    borderLeft: v,
    borderRight: v
  }
}


export const borderY = v => {
  return {
    borderTop: v,
    borderBottom: v
  }
}